import React, { useEffect } from 'react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useAuth } from '../../hooks/useAuth';
import toast from 'react-hot-toast';

const AdminRoute = () => {
  const { user, isAuthenticated, isAdmin } = useAuth();
  const location = useLocation();
  
  useEffect(() => {
    // Додаємо детальне логування для діагностики
    console.log('AdminRoute - User data:', user);
    console.log('AdminRoute - Is authenticated:', isAuthenticated);
    console.log('AdminRoute - Is admin:', isAdmin);
    console.log('AdminRoute - User roles:', user?.roles);
  }, [user, isAuthenticated, isAdmin]);

  // Перевіряємо автентифікацію
  if (!isAuthenticated) {
    toast.error('Необхідно увійти в систему для доступу до адмін-панелі');
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  // Перевіряємо права адміністратора
  if (!isAdmin) {
    toast.error('У вас немає прав доступу до адмін-панелі');
    return <Navigate to="/" replace />;
  }

  // Якщо всі перевірки пройдені, відображаємо вміст адмін-панелі
  return <Outlet />;
};

export default AdminRoute;